<app-loading *ngIf="isLoading; else content"></app-loading>
<ng-template #content>
    <div *ngFor="let device of deviceFilter" class="full-width item-card-list">
        <h4 *ngIf="isB2B" class="device-title strong">
            {{'DEVICE_TYPE.' + device | translate}}
        </h4>
        <div *ngIf="getItems(device).length; else noItems" fxLayout="row wrap" fxLayoutGap="16px grid">
            <div *ngFor="let item of getItems(device);" fxFlex="25%" fxFlex.xs="100%" fxFlex.sm="33%">
                <mat-card [ngClass]="getNgClass(item.reference)" (click)="selectItem(item)">
                    <mat-card-content>
                        <div *ngIf="isB2B" class="div-offset" fxLayout="row " fxLayoutAlign="space-between center">
                            <div fxFlex="10%">
                                <mat-icon *ngIf="item.starProduct" class="star-icon"
                                    [matTooltip]="'CATALOG.STAR_PRODUCT' |translate">
                                    star
                                </mat-icon>
                            </div>
                            <mat-chip-listbox *ngIf="item.stockStatus" fxFlex="90%" fxLayoutAlign="end">
                                <mat-chip-option disableRipple="true" selectable="false">
                                    {{ 'CATALOG.' + item.stockStatus | translate }}
                                </mat-chip-option>
                            </mat-chip-listbox>
                        </div>
                        <img class="item-img top10" [src]="item.imageUrl" [alt]="item.title ">
                        <h5 class="top10 strong">
                            <a *ngIf="item.productLink; else noLink" [href]="item.productLink" class="product-link"
                                target="_blank">
                                {{ item.title }}
                            </a>
                            <ng-template #noLink>
                                {{ item.title }}
                            </ng-template>
                        </h5>
                        <h6 class="italic"> {{ item.subtitle }}</h6>
                        <ng-container *ngIf="isB2B">
                            <h5 class="strong"> {{ getStockDisplay(item.stock) }}</h5>
                            <h6 fxLayoutAlign="end end" class="reference">
                                {{ 'ref. ' + item.reference }}
                            </h6>
                        </ng-container>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
        <ng-template #noItems>
            <div class="flex-center">
                <div class="noItems">
                    {{ 'CATALOG.NO_ITEMS' | translate }}
                </div>
            </div>
        </ng-template>
    </div>
</ng-template>